import s from './AnimatedPanel.module.scss'
import type { AnimatedPanelProps } from './AnimatedPanel.props'

export function AnimatedPanel({ text }: AnimatedPanelProps) {
  return (
    <div className={s.wrapper}>
      <div
        className={s.animatedPanel}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  )
}
